import React from 'react';
import { Box, Typography, Button } from '@material-ui/core';
import { Add } from '@material-ui/icons';
import { Link } from "react-router-dom";
import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles(theme => ({
    TitleCreate: {
        fontFamily: 'UniviaPro-Medium',
        fontSize: '18px',
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.2,
        letterSpacing: 'normal',
        color: '#4f5064',
    },
    TextBtn: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '9px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.22,
        letterSpacing: '0.36px',
        color: '#ffffff',
    },
   
    subText: {
        fontFamily: 'UniviaPro-Medium',
        fontWeight: '500',
        lineHeight: "13.2px",
        marginLeft: 10,
        letterSpacing: 'normal',
        color: '#88898c',
        fontSize: 11
    }
}))

const PageListLabel = ({ buttonHidden, label, btnText, pathname, total }) => {
    const classes = useStyles();
    return (
        <Box display="flex" py={3}>
            <Box my='auto' display="flex" flexDirection="row" alignItems="center">
                <Typography className={classes.TitleCreate}>{label}</Typography>
                {
                    total > 0 ? <Typography className={classes.subText}>({total})</Typography>
                        : <Typography className={classes.subText}>(0)</Typography>
                }
            </Box>
            <Box flexGrow={1} display='flex' justifyContent='flex-end'>
                {
                    !buttonHidden && (
                        <Box display='flex' justifyContent='flex-end' my='auto' ml={4}>
                            <Button
                                color='primary'
                                variant="contained"
                                endIcon={<Add className={classes.TextBtn}></Add>}
                                component={Link}
                                to={{ pathname: pathname }}
                            >
                                <Typography className={classes.TextBtn}>{btnText}</Typography>
                            </Button>
                        </Box>
                    )
                }
            </Box>
        </Box>
    );
}

export default PageListLabel;
